import { EncryptStorage } from 'encrypt-storage';
import { useLocation } from 'react-router-dom';

export const encryptStorage =
  process.env.NODE_ENV === 'development'
    ? sessionStorage
    : new EncryptStorage(process.env.REACT_APP_ENCRYPT_STORAGE_KEY, {
        storageType: 'sessionStorage',
      });

export const validarPath = () => {
  const location = useLocation();
  const paso = encryptStorage.getItem('p');

  if (paso) {
    if (paso !== location.pathname) {
      encryptStorage.setItem('p', paso);
      window.location.replace(paso);
    }
  } else {
    window.location.replace(paso);
  }
};

export default {
  encryptStorage,
  validarPath,
};
